import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

const styles = css`
  .bia-wrapper {
    margin-left: -53px;
    margin-right: -56px;
    background-color: white;
    padding-left: 53px;
    margin-bottom: 0px;
    padding-bottom: 15px;
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-right: -9px;
      padding-bottom: 20px;
    }
  }
  .bia-page-heading {
    font-family: 'Nunito';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
    text-transform: uppercase;
    color: ${(props) => props.theme.colors.PRIMARY.DARK};
    background-color: ${(props) => props.theme.colors.WHITE};
    border-bottom: 0px;
    margin-bottom: 0px;
    margin-right: 56px;
    margin-top: 20px;

    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      justify-content: space-between;
      margin-right: 0px;
    }
  }
  &.orders-carousel-mobile-view {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: flex;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: none;
    }
  }
  &.orders-carousel-tablet-desktop-view {
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      display: none;
    }
    @media ${(props) => props.theme.mediaQuery.medium} {
      display: flex;
    }
  }
  &.no-order-tile {
    width: 100%;
    .no-order-tileWrapper {
      padding: ${(props) =>
        `${props.theme.spacing.ELEM_SPACING.LRG} ${props.theme.spacing.ELEM_SPACING.MED}`};
    }
  }
  .order-detail-link-wrapper {
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  .tileWrapper {
    display: flex;
    flex-direction: column;
    margin-bottom: 0;
    border: 1px solid #d8d8d8;
    border-radius: 6px;
    background-color: ${(props) => props.theme.colors.WHITE};
  }
  &.orders-redesign-carousel-new {
    width: 100%;
    flex-direction: column;
    .slick-track {
      display: inline-flex;
    }
    .slick-slider {
      padding: 0;
    }
    .slick-slide {
      max-width: 145px;
    }
    .slick-dots {
      justify-content: flex-start;
      position: relative;
      margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG_1};
    }
    .slick-dots ul {
      margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
    .slick-dots li {
      margin: 0 ${(props) => props.theme.spacing.ELEM_SPACING.SM} 0 0;
      width: 40px;
      height: 4px;
    }
    .slick-dots li button {
      width: 40px;
      height: 4px;
    }
    .slick-dots li button:before {
      width: 40px;
      height: 4px;
      border-radius: 0;
      background: #b0b0b0;
    }
    .slick-dots li.slick-active button:before {
      background: ${(props) => props.theme.colorPalette.blue[900]};
    }
   
    .slick-next {
      right: 40px;
      top: -25px;
      width: 18px;
      height: 21px;
      padding: 19px;
      background:  ${(props) => props.theme.colorPalette.gray[3400]}  url(${(props) => getIconPath('icon-carrot-black-small', props)}) no-repeat center center;
      border-radius: 100%;
    }
   
    .slick-prev {
      top: -25px;
      left: calc(100% - 120px);
      background:  ${(props) => props.theme.colorPalette.gray[3400]} url(${(props) => getIconPath('icon-carrot-black-small', props)}) no-repeat center center;
      border-radius: 100%;
      padding: 19px;
    }
    .slick-slide > div > div {
      text-align: left;
    }
  }
`;

export default styles;
